import React from "react";
import Slider from "react-slick";
import { FaSearch } from "react-icons/fa";
// Load available client logos from src/clients
const clientLogos = [
  require("../clients/Pertochmical.png"),
  require("../clients/ImpcatSol.png"),
  require("../clients/ClassicKabyan.png"),
  require("../clients/PressAccount.png"),
  require("../clients/urokul.png"),
  require("../clients/Milanoplus.png"),
  require("../clients/WomensEMpire.png"),
  require("../clients/KusinaRest.png"),
  require("../clients/SwadeshiBhandar.png"),
  require("../clients/NewStar_Logo.png"),
  require("../clients/SanjeevnLogo.png"),
];
function Home() {
  return (
    <>
      {/* HERO SECTION */}
      <section className="hero">
       <div className="hero-left">
  <h2>Welcome to</h2>
  <h1>Kriva Bharat Private Limited</h1>
  <p>Empowering Businesses Through Smart Software Solutions</p>

  {/* Search Box */}
  <div className="search-box">
    <input
      type="text"
      placeholder="Search services, products, solutions..."
    />
    <button className="search-btn">
  <FaSearch />
</button>
  </div>
</div>

        <div className="hero-right">
          <img src="/imgbg.png" alt="Hero" />
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about-section" id="about">
        <div className="about-container">
        
           <div className="about-text">
              <p>
                Kriva Bharat Private Limited is an innovative IT software development
                company delivering customized and scalable digital solutions across
                industries including Healthcare, Construction, Hospitality, Supply
                Chain, and Enterprise Management.
              </p>

              <p>
                We specialize in developing intelligent, secure, and user-friendly
                software systems that streamline operations, increase efficiency,
                and drive business growth.
              </p>
            </div>
        </div>
      </section>

      {/* CORE STRENGTHS */}
      <section className="strength-section" id="service">
        <div className="strength-container">
          <h2>🚀 Our Core Strengths</h2>
          <div className="strength-grid">
            <div className="strength-card">
              <div className="strength-icon">💻</div>
              <h3>Custom Software Development</h3>
              <p>Tailored solutions built for your unique business needs</p>
            </div>

            <div className="strength-card">
              <div className="strength-icon">☁️</div>
              <h3>Cloud-Based Solutions</h3>
              <p>Scalable and flexible cloud infrastructure</p>
            </div>

            <div className="strength-card">
              <div className="strength-icon">🔒</div>
              <h3>Secure & Scalable Architecture</h3>
              <p>Enterprise-grade security with unlimited growth potential</p>
            </div>

            <div className="strength-card">
              <div className="strength-icon">📊</div>
              <h3>Industry-Specific ERP Solutions</h3>
              <p>Comprehensive ERP systems for every industry vertical</p>
            </div>

            <div className="strength-card">
              <div className="strength-icon">🛡️</div>
              <h3>24/7 Technical Support</h3>
              <p>Round-the-clock dedicated technical team</p>
            </div>

            <div className="strength-card">
              <div className="strength-icon">⚡</div>
              <h3>Fast & Reliable</h3>
              <p>Lightning-fast performance and 99.9% uptime guarantee</p>
            </div>
          </div>
        </div>
      </section>

  <section className="aboutus-cta">
        <div className="aboutus-container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Get in touch with our team to discuss your software needs</p>
          <button className="aboutus-cta-btn">Contact Us Today</button>
        </div>
      </section>
     
        <section className="aboutus-values">
        <div className="aboutus-container">
          <h2>Our Core Values</h2>
          
          <div className="values-grid">
            <div className="value-item">
              <span className="value-icon">💼</span>
              <h4>Innovation</h4>
              <p>Continuously innovating to stay ahead of market trends</p>
            </div>

            <div className="value-item">
              <span className="value-icon">🤝</span>
              <h4>Collaboration</h4>
              <p>Working closely with clients to understand their unique needs</p>
            </div>

            <div className="value-item">
              <span className="value-icon">✅</span>
              <h4>Excellence</h4>
              <p>Delivering high-quality solutions with attention to detail</p>
            </div>

            <div className="value-item">
              <span className="value-icon">🔒</span>
              <h4>Security</h4>
              <p>Ensuring data protection and system reliability at all times</p>
            </div>

            <div className="value-item">
              <span className="value-icon">⚡</span>
              <h4>Efficiency</h4>
              <p>Optimizing processes to deliver maximum value</p>
            </div>

            <div className="value-item">
              <span className="value-icon">🌍</span>
              <h4>Sustainability</h4>
              <p>Building solutions that contribute to long-term growth</p>
            </div>
          </div>
        </div>
      </section>

 {/* BRAND LINE */}
    <section className="brand-section" id="contact">
  <div className="brand-container">
    <h2>Our Trusted Clients</h2>

    <Slider
  dots={false}
  infinite={true}
  speed={2000}
  slidesToShow={5}
  slidesToScroll={4}
  autoplay={true}
  autoplaySpeed={2000}
  arrows={true}
  responsive={[
    {
      breakpoint: 1024,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 2 },
    },
  ]}
>
      {clientLogos.map((logo, idx) => (
        <div className="client-logo" key={idx}>
          <img src={logo} alt={`Client ${idx + 1}`} />
        </div>
      ))}
    </Slider>
  </div>
</section>
    </>
  );
}

export default Home;
